var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isThemeLoading)?_c('div',[_c('VersionChecker'),_c('keep-alive',[_c('router-view'),_c('router-view',{attrs:{"name":"helper"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }